import { Component, OnInit } from '@angular/core';
import { IMenu } from '../../models/roles/access-permission';
import { IRole } from 'src/app/models/roles/role';
import { CommonMethods } from 'src/app/common-methods';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit{
  ngOnInit(): void {
    this.role  = CommonMethods.getItem("role");
  }
  public IMENU = IMenu;
  role:any;

  /**
   * To close the sidebar if user clicks on body for tab/mobile
   */
  closeSidebar() {
    const sidebar = document.getElementById('sidebar');
    if (window.innerWidth <= 991) {
      sidebar?.classList.remove('active');
    }
  }
}
